export default {
    followUs: 'Follow us on social media',
    buy: 'Buy in cash',
    personalPurchaseLink: 'customer-service-center',
}